(() => {
  function initializeDates(root = document) {
    root.querySelectorAll('[data-delivery-date]').forEach(input => {
      const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Bogota', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      const value = type => parts.find(part => part.type === type).value;
      const minimum = new Date(Date.UTC(Number(value('year')), Number(value('month')) - 1, Number(value('day'))));
      minimum.setUTCDate(minimum.getUTCDate() + (Number(input.dataset.leadDays) || 0));
      input.min = minimum.toISOString().slice(0, 10);
    });
  }
  initializeDates();
  document.addEventListener('shopify:section:load', event => initializeDates(event.target));
  document.addEventListener('submit', event => {
    const date = event.target.querySelector('[data-delivery-date]');
    if (!date) return;
    initializeDates(event.target);
    if (!date.checkValidity()) { event.preventDefault(); event.stopImmediatePropagation(); date.reportValidity(); }
  }, true);
  document.addEventListener('click', event => {
    if (!event.target.closest('.nav-dropdown')) document.querySelectorAll('.nav-dropdown[open]').forEach(menu => menu.open = false);
    const button = event.target.closest('[data-motion-toggle]');
    if (!button) return;
    const section = button.closest('[data-floral-motion]');
    const paused = section.dataset.paused !== 'true';
    section.dataset.paused = String(paused);
    button.setAttribute('aria-pressed', String(paused));
    button.textContent = paused ? 'Reanudar movimiento' : 'Pausar movimiento';
  });
})();

// Native details menus stay accessible with keyboard and touch.
document.addEventListener('toggle', event => {
  if (!event.target.matches('.nav-dropdown') || !event.target.open) return;
  document.querySelectorAll('.nav-dropdown[open]').forEach(menu => { if (menu !== event.target && !menu.contains(event.target)) menu.open = false; });
}, true);
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.nav-dropdown[open]').forEach(menu => { menu.open = false; if (menu.contains(document.activeElement)) menu.querySelector('summary').focus(); });
});
